import React, { useContext, useEffect } from 'react';
import loadable from '@loadable/component';
import ThemeContext from '../../context/themeContext';
import { AFFILIATES } from '../../constants/appConstant';
import { isHEMmtDomain, isMmtDomain } from '../../utils/appUtils';
import Fallback from '../LazyloadFallback';
import { MAIN_HEADER } from '../../constants/componentNames';
import { getIframeValue } from '../../utils/browserUtils';
import './header.css';

const Header = loadable(() => /* webpackChunkName: 'MMT-Header' */ import('./MmtHeader'), {
  fallback: <Fallback componentName={MAIN_HEADER} />,
  ssr: false,
});

const AffiliateHeader = loadable(
  () => /* webpackChunkName: 'MMT-Header-aff' */ import('common-aff-header'),
  {
    fallback: <Fallback componentName={MAIN_HEADER} />,
    ssr: false,
  }
);

const ExpertHeader = loadable(
  () => /* webpackChunkName: 'MMT-FlightsExpertHeader' */ import('MMT-UI/FlightsExpertHeader'),
  {
    ssr: false,
  }
);

export const PAGE_NAME = {
  LISTING: 'LISTING',
  DETAIL: 'DETAIL',
  REVIEW: 'REVIEW',
  THANKYOU: 'THANKYOU',
};

const GI_PAGENAME_HIDE = [PAGE_NAME.LISTING, PAGE_NAME.DETAIL];
const HDFC_PAGENAME_HIDE = [
  PAGE_NAME.LISTING,
  PAGE_NAME.DETAIL,
  PAGE_NAME.REVIEW,
  PAGE_NAME.THANKYOU,
];

const CommonHeader = props => {
  const { backgroundHeight = '68px', pageName = '', classes = '' } = props;
  const checkShowAffAgentLogin = { showAffAgentLogin: true };
  const { affiliateDetails } = useContext(ThemeContext);
  const isMmt = isMmtDomain();
  let showHeader = true;

  if (isHEMmtDomain()) {
    return (
      <div className={`holHeaderSection ${classes}`}>
        <ExpertHeader {...{ isSingle: true, isLDAPFlow: true }} />;
      </div>
    );
  }

  if (pageName === PAGE_NAME.REVIEW || pageName === PAGE_NAME.THANKYOU) {
    showHeader = [
      AFFILIATES.MMT,
      AFFILIATES.GOIBIBO,
      AFFILIATES.INDIGO,
      AFFILIATES.HDFC_SB,
      AFFILIATES.AIX,
    ].includes(affiliateDetails.affiliateIdentifier);
  }
  if (!affiliateDetails.affiliateIdentifier) {
    return null;
  }
  if (affiliateDetails.affiliateIdentifier !== AFFILIATES.MMT && !isMmt) {
    let showAffPoweredBy = true;
    let showLoginBtn = true;
    if (
      affiliateDetails.affiliateIdentifier === AFFILIATES.GOIBIBO &&
      GI_PAGENAME_HIDE.indexOf(pageName) !== -1
    ) {
      showAffPoweredBy = false;
      showLoginBtn = false;
    }
    if (
      affiliateDetails.affiliateIdentifier === AFFILIATES.HDFC_SB &&
      HDFC_PAGENAME_HIDE.indexOf(pageName) !== -1
    ) {
      showAffPoweredBy = false;
    }

    return (
      showHeader && (
        <div className={`holHeaderSection ${classes}`}>
          <AffiliateHeader
            aff={affiliateDetails.affiliateIdentifier}
            backgroundHeight={backgroundHeight}
            headerHeight={'40px'}
            showPoweredBy={showAffPoweredBy}
            showLoginBtn={showLoginBtn}
            isIframe={getIframeValue()}
          />
        </div>
      )
    );
  }
  return (
    showHeader && (
      <div className={`holHeaderSection ${classes}`}>
        <Header {...{ ...props, ...checkShowAffAgentLogin }} />
      </div>
    )
  );
};
export default CommonHeader;
